<template>
  <div>
    <NavigatorItem
      :navigation="navigation"
      :indent="indent"
      :selectedObjectId="selectedObjectId"
      @updateNavigation="updateNavigation"
    />
    <template v-if="navigation.className == 'Block'">
      <inline-object-navigator
        v-for="inlineObject in navigation.inlineObjects"
        :key="inlineObject.id"
        :indent="indent + 1"
        :navigation="inlineObject"
        :selectedObjectId="selectedObjectId"
        @updateNavigation="updateNavigation"
      />
    </template>
    <template v-if="navigation.className == 'ListElement'">
      <block-object-navigator
        v-for="listItem in navigation.listItems"
        :key="listItem.id"
        :indent="indent + 1"
        :navigation="listItem"
        :selectedObjectId="selectedObjectId"
        @updateNavigation="updateNavigation"
      />
    </template>
    <template v-if="navigation.className == 'ListItem'">
      <block-object-navigator
        v-for="blockObject in navigation.blockObjects"
        :key="blockObject.id"
        :indent="indent + 1"
        :navigation="blockObject"
        :selectedObjectId="selectedObjectId"
        @updateNavigation="updateNavigation"
      />
    </template>
    <template v-if="navigation.className == 'MultiEntry'">
      <block-object-navigator
        v-for="multiEntryOption in navigation.multiEntryOptions"
        :key="multiEntryOption.id"
        :indent="indent + 1"
        :navigation="multiEntryOption"
        :selectedObjectId="selectedObjectId"
        @updateNavigation="updateNavigation"
      />
    </template>
    <!-- <template v-if="navigation.className == 'MultiEntryOption'">
      <block-object-navigator
        v-for="blockObject in navigation.blockObjects"
        :key="blockObject.id"
        :indent="indent + 1"
        :navigation="blockObject"
        :selectedObjectId="selectedObjectId"
        @updateNavigation="updateNavigation"
      />
    </template> -->
    <template v-if="navigation.className == 'Qa' && navigation.question">
      <NavigatorItem
        :navigation="navigation.question"
        :indent="indent + 1"
        :selectedObjectId="selectedObjectId"
        @updateNavigation="updateNavigation"
      />
      <block-object-navigator
        v-for="blockObject in navigation.question.blockObjects"
        :key="blockObject.id"
        :indent="indent + 2"
        :navigation="blockObject"
        :selectedObjectId="selectedObjectId"
        @updateNavigation="updateNavigation"
      />
    </template>
    <template v-if="navigation.className == 'Qa' && navigation.answer">
      <NavigatorItem
        :navigation="navigation.answer"
        :indent="indent + 1"
        :selectedObjectId="selectedObjectId"
        @updateNavigation="updateNavigation"
      />
      <block-object-navigator
        v-for="blockObject in navigation.answer.blockObjects"
        :key="blockObject.id"
        :indent="indent + 2"
        :navigation="blockObject"
        :selectedObjectId="selectedObjectId"
        @updateNavigation="updateNavigation"
      />
    </template>
    <template v-if="navigation.className == 'SectionElement'">
      <block-object-navigator
        v-for="blockObject in navigation.blockObjects"
        :key="blockObject.id"
        :indent="indent + 1"
        :navigation="blockObject"
        :selectedObjectId="selectedObjectId"
        @updateNavigation="updateNavigation"
      />
    </template>
    <template v-if="navigation.className == 'Table'">
      <template v-if="navigation.tableHeader">
        <NavigatorItem
          :navigation="navigation.tableHeader"
          :indent="indent + 1"
          :selectedObjectId="selectedObjectId"
          @updateNavigation="updateNavigation"
        />
        <NavigatorItem
          v-for="column in navigation.tableHeader.columns"
          :key="column.id"
          :navigation="column"
          :indent="indent + 2"
          :selectedObjectId="selectedObjectId"
          @updateNavigation="updateNavigation"
        />
      </template>
      <template v-for="row in navigation.rows">
        <NavigatorItem
          :key="row.id"
          :navigation="row"
          :indent="indent + 1"
          :selectedObjectId="selectedObjectId"
          @updateNavigation="updateNavigation"
        />
        <template v-for="cell in row.cells">
          <NavigatorItem
            :key="cell.id"
            :navigation="cell"
            :indent="indent + 2"
            :selectedObjectId="selectedObjectId"
            @updateNavigation="updateNavigation"
          />
          <block-object-navigator
            v-for="blockObject in cell.blockObjects"
            :key="blockObject.id"
            :indent="indent + 3"
            :navigation="blockObject"
            :selectedObjectId="selectedObjectId"
            @updateNavigation="updateNavigation"
          />
        </template>
      </template>
    </template>
  </div>
</template>

<script>
import NavigatorItem from "@/components/document/revision/navigator/NavigatorItem";
export default {
  name: "BlockObject",
  props: ["navigation", "indent", "selectedObjectId"],
  components: { NavigatorItem },
  methods: {
    updateNavigation(navigation) {
      //   console.log(navigation);
      this.$emit("updateNavigation", navigation);
    }
  }
};
</script>